export const dataLayerEvent = (event) => {
  if (event && typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({ event })
  }
}
